import { UnauthorizedComponent } from './core/components/unauthorized/unauthorized.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { AuthGuard } from './core/guards/auth.guard';
import { BlankComponent } from './layouts/blank/blank.component';
import { LayoutComponent } from './layouts/layout/layout.component';
import { BlankNewComponent } from './layouts/blank-new/blank-new.component';

const routes: Routes = [
  {
    path: '', redirectTo: '/consolidado', pathMatch: 'full'
  },
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [AuthGuard]
  },
  {
    path: '',
    component: BlankComponent,
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '', 
    component: BlankNewComponent,
    loadChildren: () => import('./new-auth/new-auth.module').then(m => m.NewAuthModule),
  },
  {
    path: 'sin-autorizacion',
    component: UnauthorizedComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
